/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ quarter: NonNullable<unknown> }} Partner_Payout_Quarter_RunningInputs */



/**
* | output |
* | --- |
* | "{quarter} · still running" |
*
* @param {Partner_Payout_Quarter_RunningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_payout_quarter_running = /** @type {((inputs: Partner_Payout_Quarter_RunningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Payout_Quarter_RunningInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.quarter} · läuft noch`)
	return /** @type {LocalizedString} */ (`${i?.quarter} · still running`)
});